import { makeStyles, createStyles } from '@material-ui/core'
import {INFO_BACKGROUND, INFO_COLOR} from "../../../../../../themes/themeConfigurator";

export const styles = theme => createStyles({
  tooltip: {
    fontSize: 12,
  },
  transactionType: {
    fontSize: 16,
  },
  chip: {
    background: INFO_BACKGROUND,
    color: INFO_COLOR,
  },
  tableMainHeadline: {
    fontSize: 14,
    background: '#F9F9F9',
    borderBottom: '1px solid #D9DCDF',
    color: '#838A93',
    padding: '10px 16px',
    fontFamily: "Roboto-Bold",
  },
  headerContainer: {
    borderBottom: 'none',
    padding: '0px !important',
    marginBottom: 0,
    zIndex: 'auto',
    alignItems: 'center'
  },
  widgetContainer: {
    boxShadow: 'none !important',
    border: 'none !important',
    padding: 0,
    borderRadius: 8,
  },
  contentContainer: {
    '&:not(.hidden)': {
      marginBottom: theme.spacing(4),
    }
  }
});

export default makeStyles(styles)